import { useEffect } from 'react'
import { useDocumentLimits } from '@query'
import { useBusinessContext } from '@context'
import { useDebouncedValue } from './useDebouncedValue'

export const useDocumentLimitStatus = (date?: string | null) => {
  const { data: business } = useBusinessContext()
  const isAgencyCustomer = business?.subscription_source === 'AGENCY'

  const { debouncedValue: debouncedDocumentDate, setValue: setDebouncedDocumentDate } =
    useDebouncedValue<string | null | undefined>({
      delay: 500,
      initialValue: date
    })

  useEffect(() => {
    setDebouncedDocumentDate(date)
  }, [date, setDebouncedDocumentDate])

  const { data: documentLimits } = useDocumentLimits(debouncedDocumentDate, {
    enabled: !isAgencyCustomer && !!debouncedDocumentDate
  })

  const isDocumentLimitReached =
    !isAgencyCustomer && !!debouncedDocumentDate && (documentLimits?.usage_percentage ?? 0) >= 100

  return { documentLimits, isDocumentLimitReached }
}
